/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_upload': {
    width: 14,
    height: 17,
    viewBox: '0 0 14 17',
    data: '<defs><path pid="0" d="M9 16h6v-6h4l-7-7-7 7h4v6zm-4 2h14v2H5v-2z" id="svgicon_icon_upload_a"/></defs><g transform="translate(-5 -3)" _fill="none" fill-rule="evenodd"><mask id="svgicon_icon_upload_b" _fill="#fff"><use xlink:href="#svgicon_icon_upload_a"/></mask><g mask="url(#svgicon_icon_upload_b)" _fill="#898D94"><path pid="1" d="M0 0h24v24H0z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_upload.js